import * as d3 from 'd3'

export default {
  methods: {

    draw_Chart() {

      let title = this.title
      let db = this.schedule.data
      let act = this.schedule.actual
      let delta = this.schedule.delta
      let cht = this.chart

      let x_ = 0, y_ = 0

      let totleArea = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, 0)`)

      if(title.visible=='Y') {
        this.draw_Text(totleArea, '', 0, title.tSize/2,  title.tSize, title.tColor, 'start', title.name)
        this.funcY = title.height
      }
      
      let data = this.rawData.find(f=> f[db.code] == db.value)
      if(this.schedule.visible != 'Y' || data == undefined) return

      // Actual - Cumulative
      let chartArea = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.funcY})`)

      y_ = act.tSize/2
      this.draw_Text(chartArea, `A_CUM_${this.localId}`, 0, y_,  act.tSize, '#333', 'start', 'Cumulative')
      this.draw_Text(chartArea, '', this.getNode(`#A_CUM_${this.localId}`) + 5, y_,  act.tSize, act.tColor, 'start', `(${data.A_CUM}%)`)

      // Actual - This Week
      let actWeek = chartArea
      .append('g')
      .attr('id', `THISWEEK_CUM_${this.localId}`)
      .attr('transform', `translate(150, ${y_})`)

      this.draw_Text(actWeek, `A_WK_${this.localId}`, 0, 0,  act.tSize, '#333', 'start', 'This Week')
      this.draw_Text(actWeek, '', this.getNode(`#A_WK_${this.localId}`) + 5, 0,  act.tSize, act.tColor, 'start', `(${data.A_WK}%)`)




      // Delta - Cumulative  
      y_ = act.tSize + this.schedule.lineGap + (delta.tSize/2)

      let cumLate = chartArea
      .append('g')
      .attr('transform', `translate(${x_}, ${y_})`)

      x_ = 0
      this.draw_Text(cumLate, `T_CUM_${this.localId}`, 0, 0,  delta.tSize, '#333', 'start', 'Plan')

      x_ = this.getNode(`#T_CUM_${this.localId}`) + 5
      this.draw_Text(cumLate, `P_CUM_${this.localId}`, x_, 0,  delta.tSize, delta.tColor, 'start', `${data.PL_CUM}%`)

      x_ = x_ + this.getNode(`#P_CUM_${this.localId}`) + 10
      this.draw_Text(cumLate, `D_CUM_${this.localId}`, x_, 0,  delta.tSize, this.gmx_deltaValue(data.D_WK), 'start', `${data.D_WK}%`)

      x_ = x_ + this.getNode(`#D_CUM_${this.localId}`) + 2
      cumLate // Icon
      .append('path')
      .attr('transform', `translate(${x_}, ${-delta.tSize/2}) scale(.7)`)
      .attr('d', this.gmx_deltaValue(data.DL_CUM, 'icon'))
      .attr('fill', this.gmx_deltaValue(data.DL_CUM))


      // Delta - This Week 
      let thisWeek = chartArea
      .append('g')
      .attr('transform', `translate(150, ${y_})`)

      x_ = 0
      this.draw_Text(thisWeek, `T_WK_${this.localId}`, 0, 0,  delta.tSize, '#333', 'start', 'Plan')

      x_ = this.getNode(`#T_WK_${this.localId}`) + 5
      this.draw_Text(thisWeek, `P_WK_${this.localId}`, x_, 0,  delta.tSize, delta.tColor, 'start', `${data.P_WK}%`)

      x_ = x_ + this.getNode(`#P_WK_${this.localId}`) + 10
      this.draw_Text(thisWeek, `D_WK_${this.localId}`, x_, 0,  delta.tSize, this.gmx_deltaValue(data.D_WK), 'start', `${data.D_WK}%`)

      x_ = x_ + this.getNode(`#D_WK_${this.localId}`) + 2
      thisWeek // Icon
      .append('path')
      .attr('transform', `translate(${x_}, ${-delta.tSize/2}) scale(.7)`)
      .attr('d', this.gmx_deltaValue(data.D_WK, 'icon'))
      .attr('fill', this.gmx_deltaValue(data.D_WK))


      // Bar Chart ------------------------------------------------------------------------------------------------------------------------------------------------------------
      if(cht.visible == 'Y') {
        let proLen = (data.A_CUM/100) * this.header.width
        y_ = act.tSize + this.schedule.lineGap + delta.tSize + this.schedule.lineGap
      
        let barChart = chartArea
        .append('g')
        .attr('id', `THISWEEK_SCH_${this.localId}`)
        .attr('transform', `translate(0, ${y_})`)

        barChart
        .append('rect')
        .attr('x', 0).attr('x', 0)
        .attr('rx', cht.radius)
        .attr('width', this.header.width).attr('height', cht.height)
        .attr('fill', '#F4F5F5')

        barChart
        .append('rect')
        .attr('x', 0).attr('x', 0)
        .attr('rx', cht.radius).attr('opacity', cht.opacity)
        .attr('width', proLen).attr('height', cht.height)
        .attr('fill', `url(#${this.localId}_${this.chart.color}_0)`)

        if(data.AC_CUM < 80) 
          this.draw_Text(barChart, ``, proLen + 2, cht.height/2+1,  cht.tSize, cht.tColor, 'start', `${data.A_CUM}%`)
        else 
          this.draw_Text(barChart, ``, proLen - 2, cht.height/2+1,  cht.tSize, cht.tColor, 'end', `${data.A_CUM}%`)
      }

      this.funcY = title.height + this.schedule.height
    },









    
  }
}